import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import './ConteudoPodcast.css';

const ConteudoPodcast = () => {
  const { id } = useParams();
  const [podcast, setPodcast] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPodcasts, setFilteredPodcasts] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL || "/api";

  // Busca os podcasts
  useEffect(() => {
    const fetchPodcasts = async () => {
      if (!searchTerm) {
        setFilteredPodcasts([]); // Se não houver termo de busca, limpar os resultados
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/podcasts?search=${searchTerm}`);
        if (!response.ok) {
          throw new Error('Erro ao carregar os podcasts');
        }
        const data = await response.json();
        setFilteredPodcasts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPodcasts();
  }, [searchTerm, apiUrl]); // Dependência do searchTerm para realizar a busca

  // Buscar podcasts quando o id for alterado
  useEffect(() => {
    const fetchPodcastById = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/podcasts/${id}`);
        if (!response.ok) {
          throw new Error('Erro ao carregar o podcast');
        }
        const data = await response.json();
        setPodcast(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPodcastById();
  }, [id, apiUrl]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (error) {
    return (

      <Box sx={{ textAlign: 'center', padding: 4 }}>
        <Typography variant="h6" color="error">{error}</Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: 4 }}>
        <Typography variant="h6" color="textSecondary">Carregando...</Typography>
      </Box>
    );
  }

  if (!podcast) {
    return (
      <Box sx={{ textAlign: 'center', padding: 4 }}>
        <Typography variant="h6" color="textSecondary">Podcast não encontrado</Typography>
      </Box>
    );
  }

  return (
    <div className="podcast-background">

      <Container sx={{ marginTop: 4, maxWidth: 'lg' }}>
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <Paper elevation={3} className="podcast-card">
          {podcast.linkImagem ? (
            <div className="podcast-image-container">
              <img src={podcast.linkImagem} alt={podcast.titulo} className="podcast-image" />
            </div>
          ) : (
            <Typography variant="body1" color="textSecondary">Imagem não disponível</Typography>
          )}

          <Box sx={{ padding: 3 }}>
            <Typography
              variant="h2"
              align="center"
              gutterBottom
              style={{
                fontFamily: "'Lato', serif",
                color: "#800020",
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                borderBottom: "4px solid #d4af37",
                paddingBottom: "10px",
                textTransform: "uppercase",
                animation: "glow 2s infinite alternate",
                marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            >{podcast.titulo}</Typography>
          </Box>

          <Divider sx={{ margin: '20px 0' }} />

          <Box sx={{ padding: 3 }}>
            <Typography
              variant="h3"
              align="center"
              gutterBottom
              style={{
                fontFamily: "'Lato', serif",
                color: "#fed136",
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                paddingBottom: "10px",
                textTransform: "uppercase",
                animation: "glow 2s infinite alternate",
                marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            >Ouça o Episódio:</Typography>
            {podcast.linkEpisodio ? (
              <audio controls className="podcast-audio-player">
                <source src={podcast.linkEpisodio} type="audio/mpeg" />
                Seu navegador não suporta o elemento <code>audio</code>.
              </audio>
            ) : (
              <Typography variant="body1" color="textSecondary">Áudio não disponível</Typography>
            )}
          </Box>

          <Divider sx={{ margin: '20px 0' }} />

          <Box sx={{ padding: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Typography
              variant="h3"
              align="center"
              gutterBottom
              style={{
                fontFamily: "'Lato', serif",
                color: "#fed136",
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                paddingBottom: "10px",
                textTransform: "uppercase",
                animation: "glow 2s infinite alternate",
                marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            > Apresentadores:</Typography>
            <Typography
              variant="body1"
              color="textPrimary"
              sx={{
                marginBottom: 2,
                fontFamily: "'Lato', sans-serif",
                color: "#444",
                lineHeight: 1.6,
                textAlign: "center",
                fontStyle: "italic",
                fontWeight: 500,
                borderLeft: "4px solid #fed136",
                paddingLeft: "10px",
              }}
              dangerouslySetInnerHTML={{
                __html: podcast.apresentadores || "Informação não disponível",
              }}
            />




            <Box>
              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Descrição:</Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                sx={{
                  marginBottom: 2,
                  fontFamily: "'Lato', serif",
                  color: "#555",
                  lineHeight: 1.6,
                  textAlign: "justify",
                  padding: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  borderRadius: "8px",
                }}
                dangerouslySetInnerHTML={{
                  __html: podcast.descricao || "Informação não disponível",
                }}
              />



              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Fonte:</Typography>
              <Typography variant="body1" color="textSecondary" sx={{ marginBottom: 2 }}>
                <div dangerouslySetInnerHTML={{ __html: podcast.fonte || 'Informação não disponível' }} />
              </Typography>

              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Produção:</Typography>
              <Typography
                variant="body1"
                color="textPrimary"
                sx={{
                  marginBottom: 2,
                  fontFamily: "'Lato', sans-serif",
                  color: "#444",
                  lineHeight: 1.6,
                  textAlign: "center",
                  fontStyle: "italic",
                  fontWeight: 500,
                  borderLeft: "4px solid #800020",
                  paddingLeft: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: podcast.producao || "Informação não disponível",
                }}
              />

              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Roteiro:</Typography>
              <Typography
                variant="body1"
                color="textPrimary"
                sx={{
                  marginBottom: 2,
                  fontFamily: "'Lato', sans-serif",
                  color: "#444",
                  lineHeight: 1.6,
                  textAlign: "center",
                  fontStyle: "italic",
                  fontWeight: 500,
                  borderLeft: "4px solid #800020",
                  paddingLeft: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: podcast.roteiro || "Informação não disponível",
                }}
              />

              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Edição:</Typography>
              <Typography
                variant="body1"
                color="textPrimary"
                sx={{
                  marginBottom: 2,
                  fontFamily: "'Lato', sans-serif",
                  color: "#444",
                  lineHeight: 1.6,
                  textAlign: "center",
                  fontStyle: "italic",
                  fontWeight: 500,
                  borderLeft: "4px solid #800020",
                  paddingLeft: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: podcast.edicao || "Informação não disponível",
                }}
              />

              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Créditos:</Typography>
              <Typography variant="body1" color="textSecondary" sx={{ marginBottom: 2 }}>
                <div dangerouslySetInnerHTML={{ __html: podcast.creditos || 'Informação não disponível' }} />
              </Typography>

              <Divider sx={{ marginY: 2 }} />
              <Typography
                variant="h3"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#fed136",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              > Créditos Detalhados:</Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                sx={{
                  marginBottom: 2,
                  fontFamily: "'Lato', serif",
                  color: "#555",
                  lineHeight: 1.6,
                  textAlign: "justify",
                  padding: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  borderRadius: "8px",
                }}
                dangerouslySetInnerHTML={{
                  __html: podcast.creditosDetalhados || "Informação não disponível",
                }}
              />





              <Divider sx={{ marginY: 2 }} />
            </Box>

          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default ConteudoPodcast;
